import React from 'react';

import {
  InvestmentOptionName,
  useLegalTermsQuery
} from 'generated/graphql';
import _ from 'lodash';
import { useLoading } from 'modules';



export type ITabName = InvestmentOptionName;

type IData = {
  [key in ITabName]: Array<{
    id: string;
    title: string;
    bodyText: string;
  }>;
};

export function useTermsCollection() {
  const tuple = useLegalTermsQuery();
  const loading = useLoading([tuple]);

  const data = React.useMemo((): IData => ({
    convertibleDebt: _.map(_.filter(tuple.data?.legalTerms, term => term.investmentOption.name === 'convertibleDebt'), t => ({
      id: t.id,
      title: t.title,
      bodyText: t.bodyText
    })),
    equity: _.map(_.filter(tuple.data?.legalTerms, term => term.investmentOption.name === 'equity'), t => ({
      id: t.id,
      title: t.title,
      bodyText: t.bodyText
    }))
  }), [tuple]);

  return {
    loading,
    data
  };
}
